import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ViewportHidepanelNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M21.6 21H2.39998C1.40618 21 0.599976 20.1937 0.599976 19.2V4.8C0.599976 3.8062 1.40628 3 2.39998 3H21.6C22.5938 3 23.4 3.8063 23.4 4.8V19.2C23.4 20.1938 22.5937 21 21.6 21ZM4.19998 17.4H19.8V6.6H4.19998V17.4Z"
        fill={color}
      />
      <path
        d="M21.6 11.1H10.5V4.79999H8.70001V19.2H10.5V12.9H21.6V11.1Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ViewportHidepanelNsk.displayName = 'ViewportHidepanelNsk';
